"use client";

import { ResponsiveModal } from "@/components/responsive-modal";
import { useI18n } from "@/locales/client";
import useAddStudySetsToFolderModal from "../hooks/use-add-studysets-to-folder-modal";
import { ManageStudySetsForm } from "./manage-studysets-form";

export const AddStudySetsToFolderModal = () => {
  const t = useI18n();
  const { isOpen, onClose, folderId } = useAddStudySetsToFolderModal();

  return (
    <ResponsiveModal
      open={isOpen}
      onOpenChange={onClose}
      title={t("manageStudySets")}
      description={t("manageStudySetsDescription")}
      form={folderId ? <ManageStudySetsForm /> : null}
    />
  );
};
